// extracted by mini-css-extract-plugin
export default {"menuBlock":"pE-z","title":"qE-z","nav":"rE-z","flexCell":"sE-z","facetLink":"tE-z"};